module.exports = "/static/media/call-waiting-sound.17fcdaf0.mp3";